"use client"

const CMIPage = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-stone-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <button
            onClick={onBack}
            className="flex items-center text-emerald-700 hover:text-emerald-800 mb-4 transition-colors"
          >
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Home
          </button>
          <h1 className="text-4xl font-bold text-charcoal-800 mb-4">Consumer Medicine Information</h1>
          <p className="text-lg text-charcoal-600">
            Important information about your Mediwhistle device for safe and effective use.
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-xl shadow-sm border border-stone-200 p-8">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-2xl font-semibold text-charcoal-800 mb-4">Product Overview</h2>
            <p className="text-charcoal-700 mb-6">
              Mediwhistle is a medical device designed to assist healthcare professionals and patients in monitoring and
              managing health conditions. This Consumer Medicine Information (CMI) provides essential details about
              proper usage, safety considerations, and important precautions.
            </p>

            <h3 className="text-xl font-semibold text-charcoal-800 mb-3">Intended Use</h3>
            <p className="text-charcoal-700 mb-6">
              The Mediwhistle device is intended for use by healthcare professionals and trained patients for monitoring
              specific health parameters as prescribed by a qualified healthcare provider.
            </p>

            <h3 className="text-xl font-semibold text-charcoal-800 mb-3">Important Safety Information</h3>
            <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
              <h4 className="font-semibold text-amber-800 mb-2">⚠️ Warnings</h4>
              <ul className="list-disc list-inside text-amber-700 space-y-1">
                <li>Always follow your healthcare provider's instructions</li>
                <li>Do not use if the device appears damaged</li>
                <li>Keep away from children when not in supervised use</li>
                <li>Do not expose to extreme temperatures or moisture</li>
              </ul>
            </div>

            <h3 className="text-xl font-semibold text-charcoal-800 mb-3">How to Use</h3>
            <ol className="list-decimal list-inside text-charcoal-700 space-y-2 mb-6">
              <li>Ensure the device is clean and properly calibrated</li>
              <li>Follow the specific instructions provided by your healthcare provider</li>
              <li>Record measurements as directed</li>
              <li>Store the device in a clean, dry place after use</li>
            </ol>

            <h3 className="text-xl font-semibold text-charcoal-800 mb-3">Maintenance and Care</h3>
            <p className="text-charcoal-700 mb-6">
              Regular maintenance is essential for accurate readings and device longevity. Clean the device according to
              the provided instructions and schedule regular calibration checks as recommended by your healthcare
              provider.
            </p>

            <h3 className="text-xl font-semibold text-charcoal-800 mb-3">When to Contact Your Healthcare Provider</h3>
            <p className="text-charcoal-700 mb-6">
              Contact your healthcare provider immediately if you experience any unusual readings, device malfunctions,
              or if you have questions about your treatment plan.
            </p>

            <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-4">
              <h4 className="font-semibold text-emerald-800 mb-2">📞 Need Help?</h4>
              <p className="text-emerald-700">
                For technical support or questions about your device, please contact our patient support team or consult
                with your healthcare provider.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CMIPage
